import React, { Component, Fragment } from "react";
import { NavLink, Redirect, Route, Switch } from "react-router-dom";
import { routesContext } from "../../../../shared/routes/routes-context";
import PromoBanner from "../../../../shared/components/banners/PromoBanner";

export default class PostHbhScoreContainer extends Component {
  static contextType = routesContext;
  render() {
    return (
      <Fragment>
        <PromoBanner />
        <section className="post-score">
          <ul className="tabs light">
            <li>
              <NavLink
                to={this.context.postScoreTotal.path}
                activeClassName="is-active"
              >
                Total Score
              </NavLink>
            </li>
            <li>
              <NavLink
                to={this.context.postScoreHbh.path}
                activeClassName="is-active"
              >
                Hole-By-Hole Score
              </NavLink>
            </li>
          </ul>
          <Switch>
            <Redirect
              exact
              from={this.context.postScoreHbh.path}
              to={this.context.postScoreHbhSelectCourse.path}
            />
            <Route {...this.context.postScoreHbhSelectCourse} />
            <Route {...this.context.postScoreHbhMyCourses} />
            <Route {...this.context.postScoreHbhRoundSetup} />
            <Route {...this.context.postScoreHbhPost} />
            <Route {...this.context.postScoreHbhSummary} />
          </Switch>
        </section>
      </Fragment>
    );
  }
}
